<template>
  <div class="user-info">
    <div class="info-section">
      <h2 class="section-title">个人信息</h2>
      <div class="info-content">
        <div class="item">
          <p>头像</p>
          <div class="avatar-wrapper">
            <img
              :src="require('@/images/微信图片_20241202113518.png')"
              alt=""
            />
            <!-- <el-button type="text" class="change-avatar">更换头像</el-button> -->
          </div>
        </div>
        <div class="item">
          <p>用户名</p>
          <span class="username">{{ user_info.username }}</span>
        </div>
        <div class="item">
          <p>密码</p>
          <el-input
            class="password"
            type="password"
            v-model="password"
          ></el-input>
          <el-button
            type="text"
            @click.s.stop="is_show_set_password_dialog = true"
          >
            <i class="el-icon-edit"></i> 修改密码
          </el-button>
        </div>
      </div>
    </div>

    <div class="auto-correct-switch" v-if="user_info.is_superuser == 2">
          <el-switch
            v-model="dify_switch"
            active-color="#983cc9"
            inactive-color="#DCDFE6"
            class="custom-switch"
            @change="setDifySwitch"
          >
          </el-switch>
          <div class="switch-label">
            <i class="el-icon-magic-stick"></i>
            <span>知识库是否开启</span>
          </div>
        </div>

    <el-divider></el-divider>

    <el-dialog
      :modal="false"
      title="修改密码"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="is_show_set_password_dialog"
      width="30%"
      :before-close="handle_close"
    >
      <el-form :model="form">
        <el-form-item label="旧密码">
          <el-input
            placeholder="请输入旧密码"
            type="password"
            v-model="form.old_password"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input
            placeholder="请输入新密码"
            type="password"
            v-model="form.new_password"
          ></el-input>
        </el-form-item>
        <el-form-item label="确定密码">
          <el-input
            placeholder="请再次输入新密码"
            type="password"
            v-model="form.new_password1"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-button class="submit" @click.stop="submit">确定</el-button>
    </el-dialog>
  </div>
</template>
<script>
import api from "@/api";
import { get_difySwitch,update_difySwitch} from "@/api/difySwitch"

export default {
  name: "UserInfoView",
  data: function () {
    return {
      password: "********",
      user_info: "",
      dify_switch: false, 
      is_show_set_password_dialog: false,
      form: {
        old_password: "",
        new_password: "",
        new_password1: "",
      },
    };
  },
  mounted() {
    this.getUserInfo();
    this.getDifySwitch(); // 获取知识库开关状态
  },
  created() {},
  computed: {
    // ...mapState("user", ["user_info"]),
  },
  methods: {
    //获取知识库开关状态
    getDifySwitch() { 
      get_difySwitch().then((res) => { 
        this.dify_switch = res.data.data.is_that;
      });
    },
    getUserInfo() {
      api.chat.userDetail().then((res) => {
        this.user_info = res.info;
        // if (res.code == 200) {
        //   this.set_model_ids(res.info);
        // }
      });
    },
    // 设置知识库开关状态
    setDifySwitch(){
      const data = {
        is_that: this.dify_switch, // 1表示开启，0表示关闭
      }
      
      update_difySwitch(data).then((res) => { 
        if(res.data.code == 200){
          this.$message.success("知识库开关状态已更新");
        }
      });
    },
    handle_close() {
      this.form = {
        old_password: "",
        new_password: "",
        new_password1: "",
      };
      this.is_show_set_password_dialog = false;
    },
    submit() {
      const form = new FormData();
      form.append("old_password", this.form.old_password);
      form.append("new_password", this.form.new_password);
      form.append("new_password1", this.form.new_password1);
      api.chat
        .updatePassword(form)
        .then((res) => {
          if (res.code == 200) {
            this.is_show_set_password_dialog = false;
            this.form = {
              old_password: "",
              new_password: "",
              new_password1: "",
            };
          } else {
            this.$message.error(res["error"]);
          }
          // const { data } = res
          // if (data['code'] === 200) {
          //   this.is_show_set_password_dialog = false
          //   this.form = {
          //     old_password: '',
          //     new_password: '',
          //     new_password1: '',
          //   }
          //   this.$message.success('修改密码成功！')
          // } else {
          //   this.$message.error(data['error'])
          // }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
  .auto-correct-switch {
    display: flex;
    align-items: center;
    padding: 16px 24px;
    background: #f8f2fc;
    border-radius: 12px;
    width: fit-content;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 12px rgba(152, 60, 201, 0.15);
      transform: translateY(-1px);
    }

    .custom-switch {
      margin-right: 16px;

      ::v-deep .el-switch__core {
        border-color: transparent;
      }
    }

    .switch-label {
      display: flex;
      align-items: center;
      color: #606266;
      font-size: 15px;

      i {
        color: #983cc9;
        margin-right: 8px;
        font-size: 20px;
      }

      span {
        font-weight: 500;
      }
    }
  }

.user-info {
  width: calc(100% - 20px);
  min-height: 780px;
  padding: 30px 20px;
  background: #fff;
  //   border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  position: relative;
  overflow-y: auto;

  .info-section {
    margin-bottom: 40px;

    .section-title {
      color: #333;
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 24px;
      padding-left: 12px;
      border-left: 4px solid #983cc9;
    }

    .info-content {
      background: #fafafa;
      border-radius: 12px;
      padding: 24px;
    }
  }

  .item {
    display: flex;
    margin-bottom: 24px;
    align-items: center;

    &:last-child {
      margin-bottom: 0;
    }

    p {
      width: 100px;
      color: #606266;
      font-weight: 500;
    }

    .avatar-wrapper {
      position: relative;

      img {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        object-fit: cover;
        border: 2px solid #983cc9;
        padding: 2px;
      }
    }

    .username {
      font-size: 16px;
      color: #333;
      font-weight: 500;
    }

    .password {
      width: 300px;
      margin-right: 20px;

      ::v-deep .el-input__inner {
        border-radius: 8px;
      }
    }

    .el-button--text {
      color: #983cc9;
      font-weight: 500;

      &:hover {
        color: lighten(#983cc9, 10%);
      }

      i {
        margin-right: 4px;
      }
    }
  }

  .use_model_list {
    margin-bottom: 24px;

    .model-select {
      width: 400px;

      ::v-deep .el-select__tags {
        background: #f8f2fc;
      }
    }

    .submit {
      background-color: #983cc9;
      color: white;
      border: none;
      margin-left: 20px;
      padding: 12px 24px;
      border-radius: 8px;
      transition: all 0.3s ease;

      &:hover {
        background-color: lighten(#983cc9, 5%);
        transform: translateY(-1px);
      }

      i {
        margin-right: 4px;
      }
    }
  }

  .auto-correct-switch {
    display: flex;
    align-items: center;
    padding: 16px 24px;
    background: #f8f2fc;
    border-radius: 12px;
    width: fit-content;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 12px rgba(152, 60, 201, 0.15);
      transform: translateY(-1px);
    }

    .custom-switch {
      margin-right: 16px;

      ::v-deep .el-switch__core {
        border-color: transparent;
      }
    }

    .switch-label {
      display: flex;
      align-items: center;
      color: #606266;
      font-size: 15px;

      i {
        color: #983cc9;
        margin-right: 8px;
        font-size: 20px;
      }

      span {
        font-weight: 500;
      }
    }
  }
}
</style>
